import React, { useState } from 'react';
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

const LoginSessionExpired = () => {
  const [isModalVisible, setIsModalVisible] = useState<boolean>(true);
  const handleLoginRedirect = () => {
    window.location.href = process.env.REACT_APP_MVC_URL || "https://enterprise.apergy.com";
  };
  const closeHandler = () => {
    handleLoginRedirect();
  };

  return (
    <div>
        {<Dialog
        header={"Your login session has expired."}
        style={{ width: "30vw" }}
        visible={true}
        onHide={closeHandler}
        draggable={false}
        resizable={false}
      >
        <div className="col-md-6 pt-4">
          <label className="form-label"> <Button style={{marginTop:"10px"}} label="Click here to log in" onClick={handleLoginRedirect}/></label>
        </div>
      </Dialog>}
    </div>
  );
};

export default LoginSessionExpired;
